/**
 * Simple observable store — replaces React useState.
 * Shallow-merges updates and notifies subscribers.
 */

export type Listener<T> = (state: T, prevState: T) => void;

export class Store<T extends Record<string, any>> {
  private state: T;
  private listeners: Set<Listener<T>> = new Set();

  constructor(initialState: T) {
    this.state = { ...initialState };
  }

  getState(): Readonly<T> {
    return this.state;
  }

  setState(partial: Partial<T>): void {
    const prevState = this.state;
    this.state = { ...this.state, ...partial };
    this.listeners.forEach((listener) => listener(this.state, prevState));
  }

  subscribe(listener: Listener<T>): () => void {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }

  destroy(): void {
    this.listeners.clear();
  }
}
